module.exports = __webpack_public_path__ + "img/staple-items-for-families-in-need.7ec6f07b.jpg";